module.exports = __webpack_public_path__ + "assets/01.42a3c6ea.pdf";